export default {"src":"/_next/static/media/fluentcommerce.9a79b83b.svg","height":43,"width":224,"blurWidth":0,"blurHeight":0};